module.exports = __webpack_public_path__ + "img/1544102385.5c4a327c.jpg";